import { httpClient } from './http.client';
import { API_BASE_URL } from './api.constants';

export interface TechniqueDefinition {
  technique_id: number;
  technique_name: string;
  dimension: string;
  dimension_name: string;
  subdimension: string;
  severity: number;
  description_en: string;
  description_ro: string;
}

let cached: TechniqueDefinition[] | null = null;
let cachedAt = 0;
const TTL = 5 * 60 * 1000;

const DEFINITIONS_URL = `${API_BASE_URL}/agent-v3/api/v3/techniques/definitions`;

export class TechniqueDefinitionsService {
  static async getDefinitions(): Promise<TechniqueDefinition[]> {
    if (cached && Date.now() - cachedAt < TTL) return cached;
    const res = await httpClient.get<{ success: boolean; data: TechniqueDefinition[] }>(DEFINITIONS_URL);
    cached = res.data;
    cachedAt = Date.now();
    return cached;
  }

  static findByName(defs: TechniqueDefinition[], name: string): TechniqueDefinition | undefined {
    return defs.find(d => d.technique_name === name);
  }
}
